export enum PopupIcons {
    InfoCircle = "Info circle",
}